<template lang="html">
  <div class="sign-up-user-term">
    <div class="sign-up-user-term__container">
      <div class="sign-up-user-term__container-checkbox" :class="{ 'sign-up-user-term__container-checkbox--danger': invalidField }">
        <input class="sign-up-user-term__container-checkbox-input" type="checkbox" id="politicas" value="politicas" v-model="termChecked">
      
        <label v-if="isNew" class="sign-up-user-term__container-checkbox-label sign-up-user-term__container-checkbox-label--new" for="politicas">
          Estou de acordo com as políticas vigentes referentes a utilização dos serviços no Cartão conforme o
          <a :href="pdfTermoUso" target="_blank">
            Termo de Uso </a>
            e dou meu Consentimento para que me enviem ofertas, novidades e demais comunicações conforme o
            <a :href="pdfAvisoPrivacidade" target="_blank"> Aviso de Privacidade</a> .
        </label>
      </div>
  
      <div v-if="invalidField" class="con-text-validation span-text-validation-danger">
        <span class="span-text-validation">{{ alertMessage }}</span>
      </div>
    </div>
  </div>  
</template>

<script>
import mixins from "@/mixins/mixins.js"

export default {
  name: 'SignUpUserTerm',

  mixins: [mixins],

  props: {
    error: {
      type: Boolean,
      default: false
    },
    checked: {
      type: Boolean,
      default: false
    },
    isNew: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      termChecked: false,
      invalidField: false,
      alertMessage: null
    }
  },
  setup() {
    const pdfTermoUso = new URL('@/assets/Termos-e-condicoes-de-uso-cartao-dasa-novo.pdf', import.meta.url).href;
    const pdfAvisoPrivacidade = new URL('@/assets/Aviso-de-privacidade-cartao-dasa.pdf', import.meta.url).href;
    
    return { pdfTermoUso, pdfAvisoPrivacidade };
  },

  watch: {
    error() {
      this.checkTermChecked()
    },
    checked(val) {
      this.termChecked = val
    },
    termChecked(val) {
      if (val) {
        this.alertMessage = null
        this.invalidField = false
      }

      this.$emit('set:userTerm', this.termChecked)
    }
  },

  mounted () {
    if (this.checked) {
      this.termChecked = this.checked
    }
  },

  methods: {
    checkTermChecked() {
      if (!this.termChecked || this.error) {
        this.alertMessage = 'O aceite do termo de consentimento é obrigatório.'
        this.invalidField = true
      }

      this.$emit('set:userTerm', this.termChecked)
      return this.termChecked;
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-up-user-term {
  &__header {
    &-title {
      font-size: 1.5rem;
      
      @media screen and (min-width: 1200px) {
        font-size: 2rem;
      }
    }
  }

  &__container {
    &-checkbox {
      $checkbox: &;
      position: relative;

      &-input {
        opacity: 0;
        position: absolute;

        &:checked {
          &+#{$checkbox} {
            &-label:before {
              background-color: #0137FD;
              border-color: darken(#0137FD, 10%);
            }

            &-label:after {
              border-bottom: 3px solid #FFF;
              border-left: 3px solid #FFF;
              width: 12px;
              height: 8px;
              transform: rotate(-45deg);
              top: 6px;
              left: 4px;
              opacity: 1;
            }
          }
        }
      }
      
      &-label {
        position: relative;
        padding-left: 1.75rem;

        &:before,
        &:after {
          content: '';
          cursor: pointer;
          left: 0rem;
          height: 20px;
          width: 20px;
          position: absolute;
          top: 5px;
          transition: all ease-in-out .2s;
        }

        &:before {
          background-color: #FFF;
          border: 1px solid #999;
          border-radius: .25rem;
          position: absolute;
          top: 2px;
        }

        &:after {
          border-bottom: 0px solid #FFF;
          border-left: 0px solid #FFF;
          opacity: 0;
        }

        &--new {
          font-size: .875rem;

          @media #{$md-and-up} {
            font-size: 1rem;
          }

          a {
            color: #0137FD !important;
            text-decoration: underline;
          }
        }
      }

      &--danger {
        border: 1px solid rgba(var(--vs-danger),1);
        margin: calc(-.5rem - 1px);
        padding: .5rem;
      }
    }
  }

  .con-text-validation {
    margin-top: .5rem;
    color: #000D40;
  }
}
</style>
